import { makeStyles } from '@material-ui/core/styles';

/**
 * Shared styles for requirement-doctor components.
 * Component-specific overrides should be defined locally within each component.
 */
export const useSharedStyles = makeStyles(theme => ({
  // Layout
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },

  // Spacing utilities
  mb1: { marginBottom: theme.spacing(1) },
  mb2: { marginBottom: theme.spacing(2) },
  mb3: { marginBottom: theme.spacing(3) },

  // Progress row (flex row with gap)
  progressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  flex1: { flex: 1 },

  // Table
  tableHead: {
    backgroundColor: theme.palette.action.hover,
  },
  tableWrapper: {
    overflowX: 'auto',
  },

  // Section title
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },

  // Status chips
  chipSuccess: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
  chipWarning: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
  },
  chipError: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
  chipInfo: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.common.white,
  },

  // Action row buttons
  cancelButton: {
    color: theme.palette.error.main,
  },
}));
